import { takeLatest, put, select, call, delay } from 'redux-saga/effects';
import { message } from 'antd';
import { getRealtimeData } from '@api/metricContainer';
import { autoRequest } from '@api/createRequestStore';

import * as actions from './actions';
import * as types from './types';
import * as selectors from './selectors';
import * as baseSelectors from '../base/selectors';
import * as baseTypes from '../base/types';
import { get } from 'lodash';
import { checkIfSampledCluster } from '@components/common/SampledDataWarning';
import { handleServerError } from '@utils/errors/serverError';

function* initRequest() {
  yield put(actions.init());
}

function* fetching() {
  const liveMode = yield select(baseSelectors.liveModeSelector);
  if (liveMode) {
    const payload = yield select(selectors.payloadSelector);
    if (!payload || payload.length < 1 || payload.filter(Boolean).length < 1) {
      return;
    }
    try {
      yield put(actions.fetching());
      yield autoRequest(getRealtimeData, types.SCOPE, payload, (response) => {
        const annotations = get(response, [0, 0, 'annotations'], []);
        checkIfSampledCluster(annotations);
      });
    } catch (error) {
      handleServerError(error);
    }
  }
}

function* removeLiveData({ index }) {
  yield put(actions.removeLiveData(index));
}

function* watchFilterRemove() {
  yield takeLatest([baseTypes.REMOVE_APPLIED_FILTER], removeLiveData);
}

function* watchInitRequest() {
  yield takeLatest([types.INIT], initRequest);
}

function* watchFetching() {
  yield takeLatest(
    [
      types.FETCH_DATA,
      baseTypes.SET_SELECTED_DIMENSION,
      baseTypes.SET_SELECTED_METRICS,
      baseTypes.SET_SELECTED_FILTERS,
      baseTypes.SET_SELECTED_INTERVAL,
      baseTypes.SET_DEFAULT_FILTER_INTERVAL,
      baseTypes.SET_LIVE_MODE,
      baseTypes.REMOVE_APPLIED_FILTER,
    ],
    fetching,
  );
}

export default [watchInitRequest, watchFetching, watchFilterRemove];
